// extracted by mini-css-extract-plugin
export var box = "EmotionalLauncher-module--box--b1802";
export var boxWrapper = "EmotionalLauncher-module--box-wrapper--6cece";
export var content = "EmotionalLauncher-module--content--5040a";
export var slide = "EmotionalLauncher-module--slide--a6c7d";
export var slideBackground = "EmotionalLauncher-module--slide-background--46d6a";
export var title = "EmotionalLauncher-module--title--a05ba";
export var variantBoxed = "EmotionalLauncher-module--variant-boxed--ba5c2";
export var variantRounded = "EmotionalLauncher-module--variant-rounded--11210";